var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavbarSection'),_c('HeaderSection'),_c('AboutSection'),_c('ServiceSection'),_c('ReviewSection'),_c('TrainingSection'),_c('ContactSection'),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }